import React, { PureComponent } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import Select from 'react-select-plus';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import Button, { WrapperButton } from '../Button';
import { CustomForm, Label, Input, TextArea } from './style';

class ContactForm extends PureComponent {
  state = {
    selectedOption: null,
    captcha: false,
    name: '',
    email: '',
    message: ''
  };

  handleChange = selectedOption => {
    this.setState({ selectedOption });
  };

  handleTextChange = (name, event) => {
    this.setState({ [name]: event.currentTarget.value });
  };

  handleSubmit = event => {
    const { selectedOption, name, message, email, captcha } = this.state;
    event.preventDefault();
    if (
      selectedOption &&
      name.trim() !== '' &&
      message.trim() !== '' &&
      email.trim() !== ''
    ) {
      this.props.onSubmit({
        name,
        message,
        email,
        captcha,
        subjectId: selectedOption && selectedOption.id
      });
    } else {
      this.props.onEmptyFields();
    }
  };

  captchaResponse = response => {
    this.setState({ captcha: response });
  };

  arrowRenderer = () => {
    return <Icon name="chevron-left" />;
  };

  menuRenderer({ options, selectValue }) {
    return (
      <ul>
        {options.map(
          group =>
            group.options && (
              <li key={group.label} className="menu-option-group">
                <h4 className="menu-option-group-title">{group.label}</h4>
                <ul>
                  {group.options &&
                    group.options.map(_option => (
                      <li
                        key={_option.id}
                        className="menu-option-item"
                        onClick={() => {
                          selectValue(_option);
                        }}
                      >
                        <span className="menu-option">{_option.label}</span>
                      </li>
                    ))}
                </ul>
              </li>
            )
        )}
      </ul>
    );
  }

  render() {
    const { selectedOption, name, message, email } = this.state;
    const { subjects, info, t } = this.props;
    const value = selectedOption && selectedOption.id;

    return (
      <CustomForm>
        <div>
          <Label>{t('common:contact.form.subject.label')}</Label>
          <Select
            name="c-subject"
            value={value}
            valueKey="id"
            onChange={this.handleChange}
            options={subjects}
            clearable={false}
            placeholder={t('common:contact.form.subject.placeholder')}
            menuRenderer={this.menuRenderer}
            arrowRenderer={this.arrowRenderer}
          />
        </div>
        <div>
          <Label>{t('common:contact.form.name.label')}</Label>
          <Input
            required
            type="text"
            id="c-name"
            onChange={event => this.handleTextChange('name', event)}
            value={name}
            placeholder={t('common:contact.form.name.placeholder')}
          />
        </div>
        <div>
          <Label>{t('common:contact.form.email.label')}</Label>
          <Input
            required
            type="email"
            id="c-mail"
            onChange={event => this.handleTextChange('email', event)}
            value={email}
            placeholder={t('common:contact.form.email.placeholder')}
          />
        </div>
        <div>
          <Label>{t('common:contact.form.message.label')}</Label>
          <TextArea
            required
            placeholder={t('common:contact.form.message.placeholder')}
            value={message}
            onChange={event => this.handleTextChange('message', event)}
          />
        </div>
        <div className="captcha">
          <ReCAPTCHA
            ref="recaptcha"
            sitekey="6LfeBVIUAAAAAJoM-kVf65_NPZ4mU3fCD3BtET-8"
            onChange={this.captchaResponse}
          />
        </div>
        <WrapperButton>
          <Button
            iconType="arrowBottomRight"
            href={'#'}
            info={info}
            noLink
            handleClick={this.handleSubmit}
          >
            {t('common:contact.form.button')}
          </Button>
        </WrapperButton>
      </CustomForm>
    );
  }
}

ContactForm.defaultProps = {
  info: true
};

ContactForm.propTypes = {
  subjects: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  info: PropTypes.bool
};

export default translate()(ContactForm);
